/**
 * German texts of the start page „Heute“ and the compact clock of the app bar (F-75). Spread into
 * the German dictionary, so they are part of {@link MessageKey}.
 */
export const todayMessagesDe = {
  "today.balance.title": "Saldo",
  "today.balance.flexitimeAccount": "Gleitzeitkonto",
  "today.balance.overtimeAccount": "Überstundenkonto",
  "today.balance.monthActual": "Ist im Monat",
  "today.balance.monthTarget": "Soll im Monat",
  "today.balance.link": "Alle Salden",
  "today.open.title": "Offen",
  "today.open.none": "Nichts offen.",
  "today.open.corrections.one": "{count} eigener Korrekturantrag wartet auf Entscheidung",
  "today.open.corrections.other": "{count} eigene Korrekturanträge warten auf Entscheidung",
  "today.open.absences.one": "{count} Abwesenheitsantrag wartet auf Entscheidung",
  "today.open.absences.other": "{count} Abwesenheitsanträge warten auf Entscheidung",
  "today.open.attributionRequests.one":
    "{count} eigener Antrag auf Projektzuordnung wartet auf Entscheidung",
  "today.open.attributionRequests.other":
    "{count} eigene Anträge auf Projektzuordnung warten auf Entscheidung",
  "today.open.findings.one": "{count} Befund in dieser Woche",
  "today.open.findings.other": "{count} Befunde in dieser Woche",
  "today.open.projectDays.one": "{count} Tag ohne vollständige Projektzuordnung",
  "today.open.projectDays.other": "{count} Tage ohne vollständige Projektzuordnung",
  "today.offline": "Ohne Verbindung nicht verfügbar. Stempeln funktioniert weiter.",
  "today.failed": "Konnte gerade nicht geladen werden.",
  "compactClock.title": "Stempeluhr",
  "compactClock.suffix": "– Stempeluhr",
  "compactClock.suffixWarning": "– Stempeluhr, Warnung beachten",
  "compactClock.summary": "{state} · {duration}",
  "compactClock.today": "Heute {work} h gearbeitet, {break} h Pause",
  "compactClock.close": "Stempeluhr schließen",
  "compactClock.confirmClockOut":
    "Jetzt gehen und den Arbeitstag beenden? Danach lässt sich das Ende nur mit einem Korrekturantrag ändern.",
  "compactClock.confirmClockOutAction": "Ja, gehen",
  "compactClock.overviewQuestion":
    "Die Tagesübersicht für die Projektzuordnung steht auf „Heute“. Auf dieser Seite gibt es nicht gespeicherte Eingaben, die beim Wechsel verloren gehen.",
  "compactClock.overviewStay": "Hier bleiben",
  "compactClock.overviewGo": "Zur Tagesübersicht",
  "compactClock.openStart": "Zur Startseite „Heute“",
} as const;
